import React, { useContext, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import RecurrentPaymentContext from "../../../../../../../infrastructure/Contexts/components/data/RecurrentPaymentsWrapper/context";
import RecurrentPaymentActions from "../../../../../../../infrastructure/Contexts/components/actions/RecurrentPaymentActionsWrapper/context";
import CobeeButton from "../../../../../CobeeButton";
import useParentStyles from "../../styles";
import useStyles from "./styles";
import CobeeTextField from "../../../../../CobeeTextField";
import { translate as t } from "../../../../../../../infrastructure/translate/localization";
import { MonetaryAmount } from "../../../../../../domain/monetary-amount";

export default function AcceptEducationStep2(): JSX.Element {
  const [payrollNumber, setPayrollNumber] = useState(0);
  const { recurrentPaymentDetail } = useContext(RecurrentPaymentContext);
  const { approveFinanceEducation, approveFinanceEducationIsLoading } =
    useContext(RecurrentPaymentActions);

  const { buttonContainer } = useParentStyles();
  const { titleStyle } = useStyles();

  const { employeeAmount, companyAmount, id } = recurrentPaymentDetail;

  const totalEmployee = employeeAmount.amountInCents;
  const totalCompany = companyAmount.amountInCents;

  const handleChange = (event) => {
    const newValue = event.target.value;
    if (newValue === "") {
      setPayrollNumber(-1);
    } else {
      setPayrollNumber(parseInt(event.target.value, 10));
    }
  };

  return (
    <Grid>
      <Typography className={titleStyle}>
        {t(
          "recurrent-payments-section.in-how-many-payrolls-will-the-price-be-charged-to-the-employee",
          {
            amount: MonetaryAmount.ofCurrency({
              amountInCents: totalEmployee,
              currency: "EUR",
            }).prettifyMoneyWithoutSymbol(),
          }
        )}
      </Typography>
      <CobeeTextField
        type="number"
        minWidth={118}
        min={0}
        max={100}
        variant="outlined"
        styleType="default"
        step="1"
        onChange={handleChange}
        value={payrollNumber === -1 ? "" : payrollNumber}
      />
      <Grid container justifyContent="flex-end" className={buttonContainer}>
        <CobeeButton
          disabled={payrollNumber === 0 || payrollNumber === -1}
          isLoading={approveFinanceEducationIsLoading}
          onClick={() =>
            approveFinanceEducation({
              splitBy: payrollNumber,
              requestId: id,
              employeeAmount: totalEmployee,
              companyAmount: totalCompany,
            })
          }
        >
          {t("actions.accept-request")}
        </CobeeButton>
      </Grid>
    </Grid>
  );
}
